import { snakeCase } from "lodash";

export function titleForColor(label: string) {
  // The function shortens the string to one word without any characters or spaces
  // for example "reopened" and "Re-Opened" mean the same thing.
  return snakeCase(label).replace(/_/g, "");
}
